import { Suspense } from "react";
import { Route, Routes, useNavigate } from "react-router";
import { useTypedParams } from "react-router-typesafe-routes";
import { PageLoading } from "~/components/loading";
import { v2Route } from "~/v2/routes";
import { RelationDetail } from "./components/RelationDetail";
import { RelationsContainer } from "./components/relations.container";

function RelationDetailRoute() {
  const { id = "" } = useTypedParams(v2Route.relations.detail);
  const navigate = useNavigate();
  return <RelationDetail id={id} onBack={() => navigate("..")} />;
}

export function RelationsRoutes() {
  return (
    <Suspense fallback={<PageLoading />}>
      <Routes>
        <Route index element={<RelationsContainer />} />
        <Route path=":id" element={<RelationDetailRoute />} />
      </Routes>
    </Suspense>
  );
}
